import React, { useState }  from 'react';
import { Button } from '../forms';
import Takeover from '../takeover';

const ListHeader = item => {

    const [isTakeover, toggleTakeover] = useState(false);

    return (
        <>
            <h3 className="statstics-list__heading"><button type="button" onClick={() => toggleTakeover(!isTakeover)}>{item.name}</button></h3>
            <Takeover isOpen={isTakeover} toggleTakeover={() => toggleTakeover()} heading={item.name}>
                {item.additionalInfo &&
                    <>
                        <p>{item.additionalInfo.definition}</p>
                        <p>
                            <a href={item.additionalInfo.definitionFileUrl} target="_blank" rel="noreferrer">Ladda hem definitioner</a>
                        </p>
                    </>
                }
                {item.companies &&
                <>
                    <h2>Företag i gren ({item.companies.length})</h2>
                    <ul>
                    {item.companies.map(company => {
                        return <li key={company.id}>{company.name}</li>
                    })}                                 
                    </ul>
                </>
                }
                <div className="statstics-list__takeover-footer">
                <Button type="button" 
                        modifiers={{
                            'form__button--muted': true,
                            'form__button--centered': true
                        }}
                        onClick={() => toggleTakeover(!isTakeover)}>Avbryt</Button>
                </div>
            </Takeover>
        </>
    );
};

export default ListHeader;